// removed by extract-text-webpack-plugin
module.exports = {"input":"os_ip","inputContainer":"os_ot","expandedInput":"os_ou os_ip","expandedInputContainer":"os_ov os_ot","close":"os_gt","eventSearchContainer":"os_ow","clear":"os_ox"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventSearchName/styles.module.css
// module id = 472
// module chunks = 27